import type { FaireProductEntity } from "../../entity_types/product";

export const p_2zkx8yj39m: FaireProductEntity = {
  token: "p_2zkx8yj39m",
  type: "product",
  name: "Patchwork color cardigan sweater sweater coat",
  brandToken: "b_m8aq2q3qv8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b06bde5dc69dfaa8a25db0cb91e7509b61ce9e5119e67ae44ebb08801a3a591e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1c0d7449ac7a9a83a4d7fdec0e523f7fa80382d0bd206e1c7b6bf8cb6c874ee0.jpeg",
    "https://cdn.faire.com/fastly/96b7cc0172c25601bad04bfa8e25c10537dfa6523a5e4b29b5fec1f994f47df2.jpeg",
    "https://cdn.faire.com/fastly/02ea156aa65a48f8a384b395f5fc5c05efadb3b6fbbc824aa2b74f44bd382c36.jpeg",
    "https://cdn.faire.com/fastly/679c1d50ca4439f471895863453928f72cee8665c731aecf04c974d02849669c.jpeg",
    "https://cdn.faire.com/fastly/7a3a4074653f418c8c596bc3c857f147005b9d52a72cb0db438cce5a018293c7.jpeg",
    "https://cdn.faire.com/fastly/2960dcf2a6508cb244598d0638c1b306f555fb981f199782cdfdd20964993edb.jpeg",
    "https://cdn.faire.com/fastly/084e33629cd02229afba61cc43d93cc94f75436d9fcbb0a541680e051bef3ce3.jpeg",
    "https://cdn.faire.com/fastly/2a1da6ae540724608232a4b7b80d0a30d48d454aa64026825e4482eaf875d14d.jpeg",
    "https://cdn.faire.com/fastly/b50898a1c516807343ef34af6dce6be233336e9b09dcd5d146ed4861695dde07.jpeg",
    "https://cdn.faire.com/fastly/958cc88e406049d5432e52401a515f78d08978f9a50167fd372e9d64e8937526.jpeg",
    "https://cdn.faire.com/fastly/39c6f68f8e82b8b07a3cad4b180861d1ce1ced291c9d007f836a4883ee800f78.jpeg",
    "https://cdn.faire.com/fastly/34881f0354039f35461c48216f74afb67cc2654c7fb26b2f715e474010c2ca02.jpeg",
  ],
  priceDollars: 29.82,
  description:
    "Patchwork color cardigan sweater sweater coat\n100% ACRYLIC\nSIZE:S,M,L,XL\nMADE IN CHINA\n\nCardigan, women's cardigan, cardigan, large size cardigan, knitted cardigan, oversized cardigan, cardigan hoodie, summer cardigan, short cardigan, long cardigan, spring cardigan, 2024 new cardigan, winter cardigan, fashionable women's cardigan, cardigan shirt, cardigan button down cardigan, loose cardigan, summer cardigan, knitted outerwear, cardigan with pockets，cardigan sweater，mens cardigan，folklore cardigan，black cardigan，red cardigan，white cardigan，womens cardigan，cropped cardigan，       crochet cardigan，long cardigan，cashmere cardigan，granny square cardigan，oversized cardigan，knit cardigan，womens cardigan sweaters，chunky cardigan，gray cardigan，long cardigan clothing，lightweight cardigan，cropped cardigan sweater，crochet cardigan pattern",
  tags: [],
  msrpDollars: 59.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:16.628Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
